<template>
  <div class="pt-8">
    <v-col cols="12" md="12" sm="12" xs="12" style="padding-top: 40px" class="mb-n12">
      <v-row class="mt-n1">
        <v-col class="text-center mt-n1">
          <p style="color: #000000; font-size: 40px">OTP Code</p>
        </v-col>
      </v-row>
      <v-row class="mt-n5">
        <v-col class="text-center">
          <span style="color: #525151; font-size: 28px" class="text-center">
            {{ $t("otp.otpcodefrom") }}</span>
          <br />
          <span style="color: #525151; font-size: 28px">
            {{ $t("otp.entering") }}
          </span>
          <br />
          <span style="color: #04449f; font-size: 20px">
            {{ $t("otp.Refcode") }}: {{ refcode }}
          </span>
        </v-col>
      </v-row>
      <v-row class="text-center">
        <v-col cols="12" md="3"></v-col>
        <v-col class="text-center" cols="12" md="6" xs>
          <v-otpinput ref="otpInput" input-classes="otp-input" class="text-center" separator="-" :num-inputs="6"
            @on-change="handleOnChange" @on-complete="handleOnComplete" />
        </v-col>
      </v-row>
      <v-row>
        <v-col cols="12" md="12" sm="12" xs="12 " align="center">
          <div>
            <v-btn :loading="loading" large :disabled="loading" class="no-uppercase border-radius-10"
              style="font-size: 20px" @click="sendOTP">
              <span style="font-size: 16px; font-weight: 500">{{ $t("button.btneesend") }}</span>
              <template v-slot:loader>
                <span style="font-size: 16px">รอ: {{countdown}}</span>
              </template>
            </v-btn>
            <v-btn large color="success" class="ma-2 white--text no-uppercase border-radius-10" style="font-size: 20px"
              @click="checkOTP">
              {{ $t("button.attendmeeting") }}
            </v-btn>
          </div>
        </v-col>
        <span class="py-16"></span>
      </v-row>
    </v-col>
  </div>
</template>
<script>
// import { mapActions } from "vuex";

export default {
  name: 'App',
  data() {
    return {
      refcode: '',
      countdown: 20,
      loading: false,
      loader: null,
      otp: '',
      dataroom: '',
      jwt: require('jsonwebtoken'),
      receivedData: '',
    }
  },
  mounted() {
    window.addEventListener('op_joinroom_onemeet', async (event) => {
      this.receivedData = event;
    })
    this.checkmobile(); //dissable oneplatform ชั่วคราว
    // if (localStorage.getItem('user-token') === null) {
    //   this.$swal
    //     .fire({
    //       title: this.$t("loginpage.pleaslogin"),
    //       // text: 'กรุณาเข้าสู่ระบบ',
    //       icon: 'warning',
    //       showCancelButton: false,
    //       confirmButtonText: 'OK',
    //       allowOutsideClick: false
    //     }).then(res => {
    //       localStorage.clear()
    //       localStorage.setItem("lang", "th")
    //       this.uuid = this.$route.query.uuid
    //       // window.location.href = '/'
    //       this.$router.push({ path: '/' + '?uuid=' + this.uuid }).catch(() => { })
    //     }
    //     )
    // } else {
    //   this.refrestoken()
    //   this.decodejwttoken()
    //   this.uuid = this.$route.query.uuid
    //   this.getdatachekroom()
    // }
  },
  watch: {
    loader() {
      const l = this.loader
      if (l) {
        this[l] = true
        this.countdown = 15
        const interval = setInterval(() => {
          this.countdown--
          if (this.countdown <= 0) {
            this[l] = false
            clearInterval(interval)
          }
        }, 1000)
        this.loader = null
      }
    }
  },
  beforeDestroy() {
    // ลบ event ที่รับค่าจากแอป
    window.removeEventListener('op_joinroom_onemeet', async (event) => {
      this.receivedData = event;
    })
  },
  created() { },
  methods: {
    handleOnComplete(value) {
      this.otp = value
      // console.log(value)
    },
    handleOnChange(value) {
      this.otp = value;
      // console.log(value)
    },
    handleClearInput() {
      this.$refs.otpInput.clearInput()
    },
    decodejwttoken() {
      var token = localStorage.getItem('user-token')
      const decryptedText = this.CryptoJS.AES.decrypt(
        token,
        process.env.VUE_APP_SECRET_KEY
      )
        .toString(this.CryptoJS.enc.Utf8)
        .replace(/"/g, '')
      var data = this.jwt.decode(decryptedText)
      this.userData = data
      // console.log('this.userData', this.userData)
    },
    getdatachekroom() {
      this.axios.get(process.env.VUE_APP_API + '/api/lv1/join/check/' + this.uuid).then(res => {
        if (res.data.result === 'Success') {
          this.dataroom = JSON.parse(this.decodeJS(res.data.data))
          // this.checkloa()
          this.sendOTP()
        }
      })
    },
    browserpage() {
      if (localStorage.getItem('user-token') === null) {
        this.$swal
          .fire({
            title: this.$t("loginpage.pleaslogin"),
            // text: 'กรุณาเข้าสู่ระบบ',
            icon: 'warning',
            showCancelButton: false,
            confirmButtonText: this.$t("button.btnok"),
            allowOutsideClick: false
          }).then(res => {
            localStorage.clear()
            localStorage.setItem("lang", "th")
            this.uuid = this.$route.query.uuid
            // window.location.href = '/'
            this.$router.push({ path: '/' + '?uuid=' + this.uuid }).catch(() => { })
          }
          )
      } else {
        this.refrestoken()
        this.decodejwttoken()
        this.uuid = this.$route.query.uuid
        this.getdatachekroom()
      }
    },
    async checkmobile() {
      const vm = this;
      var agent = vm.isMobile();
      var sharetoken = localStorage.getItem('share-token') || this.$route.query.shared_token
      if (sharetoken === null || sharetoken === undefined || sharetoken === '') {
        if (agent === "android" || agent === "ios") {
          // const zone = {
          //   zone: process.env.VUE_APP_ZONE,
          //   secret: true,
          // }
          // console.log(JSON.stringify(zone));
          this.$swal
            .fire({
              title: "ต้องการเข้าใช้งาน One Meet",
              text: "ผ่าน ONE PLATFORM หรือไม่",
              icon: "info",
              showCancelButton: true,
              confirmButtonText: "ONE PLATFORM",
              allowOutsideClick: false,
              cancelButtonText: "Web Browser",
            })
            .then((result) => {
              if (result.isConfirmed === true) {
                this.openoneplatform();
              } else {
                this.browserpage();
              }
            });
        } else {
          this.browserpage();
        }
      } else {
        const userAgent = navigator.userAgent || navigator.vendor || window.opera
        const ios = 'Mozilla/5.0 (iPhone; CPU iPhone OS 15_5 like Mac OS X) AppleWebKit/605.1.15 (KHTML, like Gecko) Version/15.5 Mobile/15E148 Safari/604.1'
        const android = "Mozilla/5.0 (Linux; Android 9; LG-H870 Build/PKQ1.190522.001) AppleWebKit/537.36 (KHTML, like Gecko) Version/4.0 Mobile Safari/604.1"
        const isTouchDevice =
          "ontouchstart" in window ||
          navigator.maxTouchPoints > 0 ||
          navigator.msMaxTouchPoints > 0;
        // const zone = {
        //   zone: process.env.VUE_APP_ZONE,
        //   secret: true,
        // }
        if ((userAgent === ios) || (userAgent === android)) {
          this.sendDataToWebView('op_joinroom_onemeet', { zone: process.env.VUE_APP_ZONE, uuid: this.$route.query.uuid, secret: 'true' });
        } else if (isTouchDevice) {
          this.sendDataToWebView('op_joinroom_onemeet', { zone: process.env.VUE_APP_ZONE, uuid: this.$route.query.uuid, secret: 'true' });
        }
      }
    },
    sendDataToWebView(type, item) {
      // item สามารถส่งเป็น string หรือ json ก็ได้
      // ส่ง item ไปที่ Flutter app โดยใช้ the 'type' method ที่ส่งมาในฟังก์ชัน
      window.flutter_inappwebview.callHandler(type, item);
    },
    async openoneplatform() {
      await this.axios
        .post(
          process.env.VUE_APP_PLATFORM_DYNAMIC_LINK +
          "/api/v2/service/create-conference-open-app",
          {
            app_id: "50b63901-ce2b-4cbd-a814-eb1208a1566e",
            zone: process.env.VUE_APP_ZONE,
            uuid: this.$route.query.uuid,
            secret: "true",
            business_id: "",
          }
        )
        .then((res) => {
          if (res.data.message === "success") {
            const deeplink = res.data.data.link;
            window.location.href = deeplink;
          }
        })
        .catch((err) => {
          console.log("err", err);
        });
    },
    isMobile() {
      var userAgent = navigator.userAgent || navigator.vendor || window.opera;
      if (
        /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(
          navigator.userAgent
        )
      ) {
        // console.log('true')
        if (/windows phone/i.test(userAgent)) {
          // alert(userAgent)
          return "windows_phone";
        }
        if (/android/i.test(userAgent)) {
          return "android";
        }
        if (/iPad|iPhone|iPod/.test(userAgent) && !window.MSStream) {
          // alert("ios")
          return "ios";
        }
        if (/Macintosh/.test(userAgent) && !window.MSStream) {
          alert(userAgent);
          // alert("ios")
          return "mac";
        }
        return "unknown";
      } else {
        // alert(false)
        // console.log('false')
        var isTouchDevice =
          "ontouchstart" in window ||
          navigator.maxTouchPoints > 0 ||
          navigator.msMaxTouchPoints > 0;
        // var isMacLike = navigator.userAgent.includes('Intel Mac OS X');
        if (isTouchDevice && !window.MSStream) {
          return "ios";
        }
        return false;
      }
    },
    async refrestoken() {
      var token = localStorage.getItem('user-token')
      await this.axios.get(process.env.VUE_APP_API + '/api/lv1/auth/refreshtoken',
        {
          headers: {
            Authorization: "bearer " + localStorage.getItem('user-token'),
          },
        }
        // await this.axios.post(process.env.VUE_APP_API + '/api/v1/authentication/refrestoken', {
        //   headers: {
        //         Authorization: 'bearer ' + token
        //       }
        // }
      ).then(res => {
        // console.log('sssss', res)
      }).catch(err => {
        this.$swal(this.$t("message.Sessiontimeout"), '', 'warning').then(result => {
          localStorage.clear()
          localStorage.setItem("lang", "th")
          window.open('/' + '?uuid=' + this.$route.query.uuid, '_self')
        })
      })
    },
    checkloa() {
      this.axios.get(process.env.VUE_APP_API + '/api/v1/ioa/checkioalevel').then(res => {
        if (res.data.result === 'Success') {
          // console.log('getdatachekroom decodeJS OTP', this.dataroom.loa)
          // console.log('checkloa OTP user Success', res.data.data.loa2)
          if (res.data.data.loa2 === 'N') {
            this.$swal
              .fire({
                title: '<span style="font-family: Sarabun; font-size: 28px;">ขออภัย กรุณายืนยันเบอร์มือถือ</span>',
                text: 'ก่อนเข้าใช้งาน : ' + 'การประชุมลับ',
                icon: 'warning',
                showCancelButton: true,
                confirmButtonColor: '#04449F',
                confirmButtonText: this.$t("button.btnok")
              }).then(res => {
                if (res.isConfirmed === true) {
                  window.open('https://one.th/')
                } else if (res.isDismissed === true) {
                  window.location.href = '/'
                  // console.log('Cancel')
                } else {
                  // console.log('Cancel')
                }
                // window.location.href = '/'
                this.checkloa()
              })
          } else {
            this.sendOTP()
          }
          //   this.dataroom = JSON.parse(this.decodeJS(res.data.data))
          //   console.log('getdatachekroom decodeJS OTP', this.dataroom)
        }
      })
    },
    sendOTP() {
      // console.log('sendOTP', localStorage.getItem('user-token'))
      this.axios.get(process.env.VUE_APP_API + '/api/lv1/otp/send/',
        {
          headers: {
            Authorization: "bearer " + localStorage.getItem('user-token')
          }
        }
      ).then(result => {
        // console.log('otp/send', JSON.parse(this.decodeJS(result.data.data.otp)))
        this.refcode = result.data.data.refcode
        this.loader = 'loading'
      })
        .catch(err => {
          console.log(' err otp/send', err)
        })
    },
    checkOTP() {
      if (this.otp === '' || this.otp.length <= 5) {
        this.$swal(this.$t("otp.otpincomplete"), this.$t("message.tryagain"), 'warning')
      } else {
        this.axios.post(process.env.VUE_APP_API + '/api/lv1/otp/check/' + this.otp + '/' + this.refcode).then(res => {
          if (res.data.result === 'Success') {
            if (res.data.message === 'OTP is valid.') {
              this.$swal
                .fire({
                  title: this.$t("otp.otpcomplete"),
                  text: res.data.message,
                  icon: 'success',
                  showCancelButton: false,
                  confirmButtonColor: '#04449F',
                  confirmButtonText: this.$t("button.btnok")
                })
                .then(res => {
                  // this.$router.push({ path: '/lobbyOTP' + '/?uuid=' + this.uuid, params: { schedule: 1 }}).catch(() => {})
                  // this.$router.push({ path: '/lobbyJoin' + '/?uuid=' + this.uuid, params: { schedule: 1 } }).catch(() => {})
                  if (res.isConfirmed === true) {
                    // this.$router.push({ path: '/lobbyJoin' + '/?uuid=' + this.uuid, params: { schedule: 1 } }).catch(() => {})
                    this.$router.push({ path: '/lobbyOTP' + '/?uuid=' + this.$route.query.uuid, params: { schedule: 1 } }).catch(() => { })
                  }
                })
            }
          } else {
            this.$swal(this.$t("otp.Invalidcode"), this.$t("otp.resendagain"), 'warning')
          }
        })
          .catch(err => {
            if (err.response.status === 400) {
              this.$swal(err.response.data.message, this.$t("otp.resendagain"), 'warning')
            } else {
              this.$swal(err.response.statusText, this.$t("otp.resendagain"), 'warning')
            }
          })
      }
      // this.$swal(this.$t("otp.Invalidcode"), this.$t("otp.resendagain"), 'warning')
    },
    decodeJS(data) {
      try {
        var bytes = this.CryptoJS.AES.decrypt(data, process.env.VUE_APP_SECRET_KEY)
        var decryptedData = JSON.parse(bytes.toString(this.CryptoJS.enc.Utf8))
        return decryptedData
      } catch (error) {
        console.log('>>>>>>>>', error)
        return error
      }
    }
  }
}

</script>

<style>
.otp-input {
  width: 100%;
  height: 150%;
  padding: 5%;
  font-size: 25px;
  border-radius: 10%;
  border: 1px solid rgba(0, 0, 0, 0.3);
  text-align: center;
}

.otp-input.error {
  border: 1px solid red !important;
}

.otp-input::-webkit-inner-spin-button,
.otp-input::-webkit-outer-spin-button {
  /* -webkit-appearance: none; */
  margin: 0;
}

.no-uppercase {
  text-transform: none;
}
</style>
